import React, { useEffect } from 'react';
import { SessionManager, SessionType } from './session-manager';
import { Route } from 'react-router';
import { BasicAuthLoginPage } from './basic-auth/basic-auth-login-page/basic-auth-login-page';
import { useSessionType } from '../../hooks/use-session-type';

const PreLogin: React.FC<{ sessionType: SessionType }> = ({ sessionType }) => {
  useEffect(() => {
    let mounted = true;

    const init = async () => {
      await SessionManager.createSession(sessionType);

      // 👉 kun auto-login for ikke BASIC_AUTH
      if (mounted && sessionType !== SessionType.BASIC_AUTH) {
        await SessionManager.session.signin();
      }
    };

    init();

    return () => {
      mounted = false;
    };
  }, [sessionType]);

  return <>redirecting...</>;
};

interface LoginRouteProps {
  path: string;
}

export const LoginRoute: React.FC<LoginRouteProps> = ({ path }) => {
  const sessionType = useSessionType();

  return (
      <Route exact path={path}>
        {sessionType === SessionType.BASIC_AUTH ? (
            <BasicAuthLoginPage />
        ) : (
            <PreLogin sessionType={sessionType} />
        )}
      </Route>
  );
};
